import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';


function pathViewWixSettingsShforms() {
  return `view/wix-settings-shforms`;
}

export function getViewWixSettingsShforms(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewWixSettingsShforms(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathWixSettings() {
  return `wix-settings`;
}

export function patchWixSettings(successCallback, errorCallback, data) {
  patchAuth({
    "path": pathWixSettings(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}
